import type { ReactNode } from "react";
import { Tag, Tooltip } from "antd";

// Features that are visible in the UI but not functional yet (blocked on an
// external integration). They render greyed out with a "Coming soon" tag and
// can't be opened or used. Remove a path here once the feature is real.
export const COMING_SOON_PATHS = new Set<string>([
  "/admin/accounting",  // needs QuickBooks/Xero OAuth
  "/admin/telephony",   // needs a voice/telephony provider
  "/admin/memberships", // needs a recurring-billing processor
  "/admin/locations",   // backend is single-location
]);

export function ComingSoonTag() {
  return (
    <Tag bordered={false} style={{ marginInlineStart: 8, fontSize: 11, lineHeight: "18px", color: "#6b7280", background: "#f3f4f6" }}>
      Coming soon
    </Tag>
  );
}

// Label for a disabled menu item / tab / option: greyed text + the tag.
export function comingSoonLabel(label: ReactNode) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", opacity: 0.55 }}>
      {label}
      <ComingSoonTag />
    </span>
  );
}

// Wraps a block of UI so it shows but can't be used: dimmed, lightly blurred,
// pointer events off, with a "Coming soon" note on top.
export function ComingSoonOverlay({ children, note }: { children: ReactNode; note?: string }) {
  return (
    <Tooltip title={note}>
      <div style={{ position: "relative" }}>
        <div aria-disabled style={{ opacity: 0.45, filter: "blur(1px)", pointerEvents: "none", userSelect: "none" }}>
          {children}
        </div>
        <div style={{ position: "absolute", top: 8, right: 8 }}>
          <ComingSoonTag />
        </div>
      </div>
    </Tooltip>
  );
}
